import classNames from "classnames";

import { ProductMarketplaceCategory } from "custom-types/Product";

import categoryData from "components/products/lib/categoryData";

export const ProductCategoryTitle: React.FC<{
  category: ProductMarketplaceCategory;
  className?: string;
}> = ({ category, className }) => {
  const data = categoryData[category.slug] || {};
  const title = data.title || category.name;

  return <h1 className={classNames("heading--xl", className)}>{title}</h1>;
};
